import Text from 'components/Text/Text';
import React from 'react';
import { IDishAllSubCategory } from 'types';
import Pop from 'components/Popover/Pop';
import style from './SubCategoriesList.module.scss';

interface ISubCategoriesList {
	data: IDishAllSubCategory[];
}

const SubCategoriesList: React.FC<ISubCategoriesList> = ({ data }) => {
	const SubCategoriesContent = () => {
		return (
			<div className={style.container}>
				{data.map((el) => (
					<div className={style.item} key={el.id}>
						<Text translationKey={el.subCategoryName} size="xs" />
					</div>
				))}
			</div>
		);
	};

	return (
		<>
			{data.length > 1 ? (
				<Pop placement="bottomLeft" content={<SubCategoriesContent />} trigger="click">
					<div className={style.wrapper}>
						<Text translationKey={data[0].subCategoryName} withTooltip={true} />
						<span className={style.showListBtn}>&middot;&middot;&middot;</span>
					</div>
				</Pop>
			) : (
				<Text translationKey={data.length ? data[0].subCategoryName : '-'} withTooltip={true} />
			)}
		</>
	);
};

export default SubCategoriesList;
